<template>
  <div class="w-100 pt-5">
    <h4 class="text-akademica px-3 mb-5"><b>SEJA ALUNO</b></h4>

    <div class="row px-5">
      <div class="col-12 col-md-4 text-center">
        <p class="text-center text-akademica mb-3">
          <img height="80" src="../../assets/img/home/online.png">
        </p>
        <h5 class="text-akademica">100% ONLINE</h5>
        <h6 class="text-light text-dark">Ambiente virtual para acessar de onde e quando estiver.</h6>
      </div>

      <div class="col-12 col-md-4 text-center">
        <p class="text-center text-akademica mb-3">
          <img height="80" src="../../assets/img/home/interação.png">
        </p>
        <h5 class="text-akademica">INTERAÇÃO</h5>
        <h6 class="text-light text-dark">Converse com seu professor, tire suas dúvidas de forma simples.</h6>
      </div>

      <div class="col-12 col-md-4 text-center">
        <p class="text-center text-akademica mb-3">
          <img height="80" src="../../assets/img/home/comodidade.png">
        </p>
        <h5 class="text-akademica">COMODIDADE</h5>
        <h6 class="text-light text-dark">Aprenda no seu tempo e no conforto que deseja.</h6>
      </div>
    </div>

    <div class="w-100 home-img-text-item px-5 py-3 pt-5 mt-5 row text-center m-0">
      <div class="col p-0 d-flex justify-content-center justify-content-md-start align-items-center">
        <div>
          <h5><b>Na Akdemica você tem a flexibilidade de estudar e aprender de forma prática.</b></h5>
          <h6 class="text-light text-dark">«Consigo estudar muito bem com essa plataforma e quando preciso tenho um suporte imediato» Patricia Reis</h6>
        </div>
      </div>
      <div class="col-md-5 d-none d-md-flex justify-content-xl-center align-items-center">
        <img height="200" src="../../assets/img/home/seja_aluno.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
